






import { Component, Vue } from 'vue-property-decorator'
import { navigateBack } from '@/helpers/route'

@Component({
  name: 'NavigateBack',
})
export default class extends Vue {
  private navigateBackOne() {
    navigateBack(this.$router)
  }
}
